import Swiper from "swiper";

class Review {
    constructor() {
        this.init();
    }

    init() {
        this.slider();
    }

    slider() {
        this.swiper = new Swiper(".mySwiper", {
            slidesPerView: 1,
            navigation: {
                nextEl: ".review_arrow-right",
                prevEl: ".review_arrow-left",
            },
            loop: true,
            speed: 1000,
            spaceBetween: 100,
            allowTouchMove: false,


        });
    }
}

new Review();
